import { create } from "zustand";
import { sidebar } from "../../constants/sidebar";

const routesRequiringConfirmation = [
  `/roles-and-templates/add-template`, // ✅
  `/roles-and-templates/edit-template/*`, // ✅
  `/operator-accounts/user-access-permission/*`, // ✅
  `/locker-fees/add-partner-fees/*`, // ✅
  `/locker-fees/edit-partner-fees/*`, // ✅
  `/locker-fees/add-user-fees/*`, // ✅
  `/locker-fees/edit-user-fees/*`, // ✅
  `/locker-storage-fees`, // ✅
  `/partners/add-profile`, // ✅
  `/partners/partner-profile/*`, // ✅
  `/partnerTypes`, // ✅
  `/branches/add-branch`, // ✅
  `/branches/branch-profile/*`, // ✅
  `/payment-mode-and-fees`, // ✅
  `/locker-time-limits`, // ✅
  `/storage-time-limits`, // ✅
  `/locker-user-template`, // ✅
  `/courier-template`, // ✅
  `/locker-cleanup-template`, // ✅
  `/mbox-behavioral-campaigns/add`, // ✅
  `/mbox-behavioral-campaigns/edit-behavioral/*`, // ✅
];

// Special sidebar configuration for partner admin pages
const partnerAdminPages = [
  {
    tag: "partner_profile",
    title: "Partner Profile",
    link: "/partners/add-profile",
  },
  {
    tag: "wallet_configuration",
    title: "Wallet Configuration",
    link: "/partners/wallet-config",
  },
  {
    tag: "admin_account",
    title: "Admin Account",
    link: "/partners/admin-account",
  },
];

const useSidebarStore = create((set) => ({
  activeAccordion: null,
  accessedSidebar: [],
  isDisabled: false,
  openChildAccordion: null,
  activeSubItem: null,
  pendingNavigation: null,
  localAccessedSidebar: [],
  isPartnerAdminPage: false, // Track if we're on partner admin pages

  setActiveSubItem: (subItem) => set({ activeSubItem: subItem }),
  setAccessedSidebar: (items) => set({ accessedSidebar: items }),
  setOpenChildAccordion: (value) => set({ openChildAccordion: value }),
  setActiveAccordion: (value) => set({ activeAccordion: value }),
  setPendingNavigation: (value) => set({ pendingNavigation: value }),
  setLocalAccessedSidebar: (items) => set({ localAccessedSidebar: items }),
  setIsPartnerAdminPage: (value) => set({ isPartnerAdminPage: value }),

  updateActiveItems: (path, accessPermissions) => {
    let activeAccordion = null;
    let activeSubItem = "";
    let isPartnerAdminPage = false;

    // Check if current path is a partner admin page
    const isPartnerAdminRoute = path.includes("/partners/add-profile");

    let accessedSidebar;

    if (isPartnerAdminRoute) {
      // Use special partner admin pages sidebar
      isPartnerAdminPage = true;
      accessedSidebar = [
        {
          type: "accordion",
          title: "Partner Setup",
          content: partnerAdminPages.filter(
            (item) => accessPermissions[item.tag] !== "0"
          ),
        },
      ];

      // Find active item in partner admin pages
      accessedSidebar.forEach((item, index) => {
        if (item.type === "accordion" && item.content.length > 0) {
          item.content.forEach((subItem) => {
            if (path.includes(subItem.link)) {
              activeAccordion = index;
              activeSubItem = subItem;
            }
          });
        }
      });
    } else {
      // Use regular sidebar
      isPartnerAdminPage = false;
      accessedSidebar = sidebar
        .map((element) => {
          const tempElement = { ...element };
          tempElement.content = tempElement.content.filter(
            (item) => accessPermissions[item.tag] !== "0"
          );
          return tempElement;
        })
        .filter((x) => x.content.length > 0);

      // Find active items in regular sidebar
      accessedSidebar.forEach((item, index) => {
        if (item.type === "accordion" && item.content.length > 0) {
          item.content.forEach((subItem) => {
            if (path.includes(subItem.link)) {
              activeAccordion = index;
              activeSubItem = subItem;
            }
          });
        }
      });
    }

    console.log({
      activeAccordion,
      activeSubItem,
      accessedSidebar,
      isPartnerAdminPage,
    });

    set({
      activeAccordion,
      activeSubItem,
      accessedSidebar,
      isPartnerAdminPage,
    });
  },

  checkAccessPermissions: (currentPage, accessPermissions) => {
    // Check if on partner admin page
    const isPartnerAdminRoute = currentPage.includes("/partners/*");

    if (isPartnerAdminRoute) {
      const currentPageData = partnerAdminPages.find((page) =>
        currentPage.includes(page.link)
      );

      if (currentPageData) {
        const requiredPermission = currentPageData.tag;
        const permission = accessPermissions[requiredPermission];
        set({ isDisabled: permission !== "1" });
      } else {
        set({ isDisabled: false });
      }
    } else {
      // Regular sidebar permission check
      const allPages = sidebar.flatMap((item) => item.content);
      const currentPageData = allPages.find((page) =>
        currentPage.includes(page.link)
      );

      if (currentPageData) {
        const requiredPermission = currentPageData.tag;
        const permission = accessPermissions[requiredPermission];
        set({ isDisabled: permission !== "1" });
      } else {
        set({ isDisabled: false });
      }
    }
  },
}));

export default useSidebarStore;
export { routesRequiringConfirmation, partnerAdminPages };
